import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./padOnVia.png"

const パッドオンビア = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { padOnVia: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="パッド・オン・ビア" helpURL={HELP_LINKS["パッド・オン・ビア"]} src={img}>
      <RadioGroup name={FIELD_NAMES["パッド・オン・ビア"]} selectedValue={values.padOnVia} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["パッド・オン・ビア"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["パッド・オン・ビア"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.padOnVia} />
    </OneClickField>
  )
}

export default パッドオンビア
